if (!customElements.get('jp-native-share')) {
  customElements.define(
    'jp-native-share',
    class JpNativeShare extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.jp-native-share__button');
        this.feedback = this.querySelector('[data-share-feedback]');

        if (!this.button || this.button.dataset.shareReady === 'true') return;

        this.button.dataset.shareReady = 'true';
        this.button.addEventListener('click', () => this.share());
      }

      async share() {
        const shareData = {
          title: this.button.dataset.shareTitle || document.title,
          url: this.button.dataset.shareUrl || window.location.href,
        };

        if (typeof navigator.share === 'function') {
          try {
            await navigator.share(shareData);
            return;
          } catch (error) {
            if (error?.name === 'AbortError') return;
          }
        }

        await this.copyLink(shareData.url);
      }

      async copyLink(url) {
        try {
          if (navigator.clipboard?.writeText && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.setAttribute('readonly', '');
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();

            const copied = document.execCommand('copy');
            textArea.remove();
            if (!copied) throw new Error('Copy command was rejected.');
          }

          this.showFeedback();
        } catch (error) {
          window.prompt('Copy this link:', url);
        }
      }

      showFeedback() {
        if (!this.feedback) return;

        window.clearTimeout(this.feedbackTimer);
        this.feedback.hidden = false;
        this.feedbackTimer = window.setTimeout(() => {
          this.feedback.hidden = true;
        }, 2200);
      }
    },
  );
}
